import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';

import InventoryStore from 'src/app_deprecated/stores/InventoryStore';

import { inventoryAtom } from 'src/app/state/inventory';

import { QueryBuilderMultiSelect } from './query-builder-multiselect';

type VendorDropdownProps = {
  disabled?: boolean;
  onChange: (value: (number | string)[]) => void;
  values: string;
};

type Vendor = {
  id: number;
  name: string;
};

export function VendorDropdown({ onChange, values, disabled = false }: VendorDropdownProps) {
  const [loading, setLoading] = useState(false);
  const { vendors } = useRecoilValue(inventoryAtom);
  const transformedVendors: Vendor[] = (vendors || []).map((vendor) => ({
    id: vendor.VendorId,
    name: vendor.VendorName,
  }));

  async function handleRefresh() {
    setLoading(true);
    await InventoryStore.refreshVendors();
    setLoading(false);
  }

  return (
    <QueryBuilderMultiSelect<Vendor>
      automationIdPrefix='vendor'
      defaultLabel='Select a vendor'
      disabled={disabled}
      idKey='id'
      items={transformedVendors}
      loading={loading}
      nameKey='name'
      refreshData={handleRefresh}
      values={values}
      onChange={onChange}
    />
  );
}
